<template lang="html">
  <div>

    <md-layout md-gutter="16" md-align="center">
      
      <md-layout md-flex="25" md-flex-small="100" md-flex-xsmall="100" class="whiteframe padding pointer" @click.native="goToInfo">
        <md-layout md-align="center" md-flex="100">
          <img style="max-height:200px;" src="../../assets/img/user.png" />          
        </md-layout>
        <md-layout md-align="center">
          <div style="font-weight:bold; font-size:24px">Mi Información</div>
        </md-layout> 
      
      </md-layout>

      <md-layout md-flex="25" md-flex-small="100" md-flex-xsmall="100" class="whiteframe padding pointer " @click.native="goToPedidos">
        <md-layout md-align="center" md-flex="100">
          <img style="max-height:200px;" src="../../assets/img/stshopcC.png" />          
        </md-layout>
        <md-layout md-align="center">
          <div style="font-weight:bold; font-size:24px">Mis Pedidos</div>
        </md-layout> 
        
      </md-layout>
    </md-layout>
  </div>
</template>

<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';

export default {
  name: 'Cuenta',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      pedidos: [],
    };
  },
  computed: {
  },
  components: {},
  methods: {
    getPedidos () {
      const idCliente = this.cliente.cliente.idinterno;
      this.resourcePedido.getPedidosCliente({ idCliente })
          .then((response) => {
            this.pedidos = response.data;            
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    toMoney,
    goToCatalogo() {
      this.$router.push({ name: 'inicio' });
    },
    goToPedidos() {
      this.$router.push({ name: 'pedido' });
    },
    goToInfo() {
      this.$router.push({ name: 'perfil' });
    },
  },
  mounted() {
    this.cart = window.cart;
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
  },
};
</script>

<style lang="scss">
.cartItems {
  .md-list-item-container{
    padding-bottom: 10px;
  }
}

.cartImage {
  max-height: 90px;
}
.cartDetails{
  margin-right:5px;
}
.cartTotal{
  font-size:20px;
  opacity: .8;
  margin-left: 5px;
}
.prices {
  text-align: right;
  padding-right: 10px;
  font-size: 20px;
}

.totalLabel{
  font-size: 30px;
  opacity: .7;
  margin-right:5px;
}

.totalData{
  font-size: 30px;
  font-weight: bold;
  opacity: .7;
}

.totales{
  padding:10px;
  text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/spa/cuenta/Cuenta.vue